import type { CharacterDetail } from '@/mocks/characterDetail';

interface StoryProps {
  detail?: CharacterDetail;
}

export default function Story({ detail }: StoryProps) {
  const chapters = detail?.story ?? [];

  return (
    <section className="bg-background-100 py-16 md:py-28">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="reveal mb-12 md:mb-16">
          <div className="mb-6 flex items-center gap-3">
            <span className="text-[11px] tracking-[0.34em] text-primary-600 uppercase">
              Story
            </span>
            <span className="h-px w-8 bg-primary-300"></span>
            <span className="text-[11px] tracking-[0.28em] text-foreground-400 uppercase">
              {detail?.storySubtitle ?? '一味 × 一境 × 一愿'}
            </span>
          </div>
          <h2 className="font-heading text-3xl tracking-[0.06em] text-foreground-950 md:text-4xl">
            它的故事
          </h2>
        </div>

        <div className="space-y-12">
          {chapters.map((chapter, index) => (
            <article
              key={chapter.heading}
              className="reveal relative"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="flex gap-5 md:gap-8">
                <div className="flex flex-col items-center">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500 text-sm font-medium text-background-50">
                    {index + 1}
                  </span>
                  {index < chapters.length - 1 && (
                    <span className="mt-2 w-px flex-1 bg-background-300/60"></span>
                  )}
                </div>
                <div className="pb-2">
                  <h3 className="font-heading text-xl text-foreground-950 md:text-2xl">
                    {chapter.heading}
                  </h3>
                  <div className="mt-4 space-y-4">
                    {chapter.paragraphs.map((paragraph) => (
                      <p
                        key={paragraph}
                        className="text-sm leading-relaxed text-foreground-600 md:text-base"
                      >
                        {paragraph}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {detail?.quote && (
          <blockquote className="reveal mt-14 rounded-lg border border-accent-200/70 bg-accent-50 px-6 py-8 text-center md:px-10">
            <p className="font-heading text-lg leading-relaxed text-foreground-800 md:text-xl">
              「{detail.quote}」
            </p>
          </blockquote>
        )}
      </div>
    </section>
  );
}